var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.67 22.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeWidth: 0.75,
    strokeLinejoin: "round",
    d: "M15.29 18.15a.482.482 0 00-.42-.23H7.58c-.17 0-.33.09-.42.23l-2.22 3.53a.509.509 0 00.43.77H17.1c.18 0 .35-.1.44-.26.09-.16.08-.35-.01-.51l-2.22-3.53zm-9.03 3.29l1.59-2.53h6.74l1.59 2.53H6.26zM22.65 1.83a.503.503 0 00-.5-.47h-3.76V.5c0-.28-.22-.5-.5-.5H4.54c-.28 0-.5.22-.5.5v.86H.51c-.26 0-.48.2-.5.47-.02.27-.35 6.57 4.28 9.63.82 3.06 3.61 5.31 6.92 5.31s6.01-2.18 6.88-5.15c.02-.01.05 0 .07-.02 4.85-3.01 4.5-9.5 4.48-9.77zM1 2.36h3.04v7.23c0 .15.01.29.02.43C1.33 7.62 1.02 3.7 1 2.36zm16.4 7.23c0 3.41-2.77 6.18-6.18 6.18-2.87 0-5.28-1.97-5.97-4.63 0-.06-.02-.12-.05-.18-.1-.44-.16-.9-.16-1.37V1.92s.01-.04.01-.07-.01-.04-.01-.07V.99H17.4v8.59zm.96.64c.02-.21.03-.42.03-.64V2.36h3.27c-.02 1.38-.34 5.49-3.3 7.88z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/Trophy.33f90451.svg";
export { ForwardRef as ReactComponent };